export default "__VITE_ASSET__wKeS$FIU__"